import { InformationalBanner, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

type ParentHandbookAutoShareBannerProps = {
  extraClasses?: string;
};

export const ParentHandbookAutoShareBanner = ({ extraClasses = '' }: ParentHandbookAutoShareBannerProps) => {
  const { t } = useTranslation();

  return (
    <InformationalBanner
      type="info"
      label={t('parentHandbook.autoShareBanner')}
      size={WidgetSizeEnum.SMALL}
      extraClasses={`text-sm ${extraClasses}`.trim()}
    />
  );
};
